import React from 'react';
import { observer } from 'mobx-react';
import { CategoryIcon } from 'common--design-library';
import { ExpandIcon } from 'desktop--design-library';

export namespace ICategoryWrapperViewNs {
    export interface IGameGroupToFilter {
        id: string;
        name: string;
    }
}

export interface ICategoryWrapper {
    graphicsPresentationId: number;
    sportName: string;
    children: React.ReactNode;
    gameGroupsToFilter: ICategoryWrapperViewNs.IGameGroupToFilter[];
    selectedGameGroupId: string;
    roleForTest?: string
    setSelectedGameGroup: (groupId: string) => void;
    isExpanded: boolean;
    canCollapseSport: boolean;
    onExpand: () => void;
}

export const CategoryWrapper: React.FC<ICategoryWrapper> = observer((props: ICategoryWrapper) => {
    return (
        <div className="category-wrapper" data-test-role={props.roleForTest}>
            <div className={`category-header`} key={'header'}>
                <span className="sport-wrapper">
                    <CategoryIcon categoryIconId={props.graphicsPresentationId} small />
                    <div className="sport-name">{props.sportName}</div>
                    {props.canCollapseSport && <ExpandIcon isExpanded={props.isExpanded} onExpand={props.onExpand} />}
                </span>
                <div className="gamegroup-wrapper">
                    {props.gameGroupsToFilter.map(g => {
                        return <div key={g.id}
                            className={`gamegroup-tab ${props.selectedGameGroupId === g.id ? 'selected' : ''}`}
                            onClick={() => props.setSelectedGameGroup(g.id)}
                        >
                            {g.name}
                        </div>
                    })}
                </div>
            </div>

            {props.children && props.isExpanded && (
                props.children
            )}
        </div>
    );
});
